<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <h4 class="mb-0">User Requirement Details</h4>
    <button class="btn btn-primary btn-sm me-3" (click)="goBack()">
      <i class="fa fa-arrow-left"></i> Back
    </button>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-md-6 mb-3">
        <strong>Name</strong>
        <p>{{ userDetails?.name }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Email</strong>
        <p>{{ userDetails?.email }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Mobile</strong>
        <p>{{ userDetails?.mobile }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Pickup Location</strong>
        <p>{{ userDetails?.pickupLocation }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Drop Location</strong>
        <p>{{ userDetails?.dropLocation }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Moving Date</strong>
        <p>{{ userDetails?.movingDate }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Created At</strong>
        <p>
          {{ userDetails?.createdAt | date: "dd-MM-yyyy hh:mm a" : "IST" }}
        </p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Requirement ID</strong>
        <p>{{ userDetails?._id }}</p>
      </div>
    </div>
  </div>
</div>
